module.exports = __webpack_public_path__ + "img/unique-mob.df412a5.webp";